<template>
  <div id="title-panel-small" class="title-panel">
    <div id="title-container">
      <h2 v-if="title">{{ title }}</h2>
      <h2 v-else><slot></slot></h2>
      <div v-if="!noCounter" class="counter">
        {{ count }}
      </div>
    </div>
    <vf-button
      v-if="buttonLabel && displayButton"
      class="action-button"
      :disabled="disabled"
      :size="buttonSize"
      :variant="buttonVariant"
      @click="onButtonClick"
      >{{ buttonLabel }}
    </vf-button>
  </div>
</template>

<script setup lang="ts">
  import VfButton from '@/components/VfButton/VfButton.vue';
  import { PropType } from 'vue';
  import { ButtonSize, ButtonVariant } from '../VfButton/VfButton.types';

  defineOptions({ name: 'TitlePanel' });

  defineProps({
    buttonLabel: {
      type: String,
    },
    count: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    displayButton: {
      type: Boolean,
      default: true,
    },
    noCounter: {
      type: Boolean,
      default: false,
    },
    onButtonClick: {
      type: Function as PropType<() => void>,
    },
    title: {
      type: String,
    },
  });

  const buttonSize = ButtonSize.LARGE;
  const buttonVariant = ButtonVariant.SECONDARY;
</script>

<style scoped lang="scss">
  @include title-panel-small;
</style>
